// extracted by mini-css-extract-plugin
export default {"hrVertical":"HrVertical_hrVertical__oDdug"};